import { DisplayTrixContent } from "@circle-react-uikit/DisplayTrixContent";
import { Typography } from "@circle-react-uikit/Typography";
import { DisplayTiptapContent } from "@circle-react/components/CommentsV3/Comment/DisplayTiptapContent";
import { StandaloneCarousel } from "@circle-react/components/Spaces/ImageSpace/FeedView/StandaloneCarousel";

import { t } from "@/i18n-js/instance";

const i18nRoot = "settings.moderation.review_flagged_content_modal";

export interface ReportFlaggedContentableProps {
  isImagePost?: boolean;
  postSlug?: any;
  spaceId?: any;
  textBody?: string;
  tiptapBody?: any;
  trixBody?: string;
}

export const ReportFlaggedContentable = ({
  textBody,
  trixBody,
  tiptapBody,
  isImagePost = false,
  postSlug,
  spaceId,
}: ReportFlaggedContentableProps) => {
  if (isImagePost && postSlug && spaceId) {
    return (
      <div className="flex flex-col gap-4">
        {tiptapBody && <DisplayTiptapContent tiptapBody={tiptapBody} />}
        <div className="-mt-2">
          <StandaloneCarousel postSlug={postSlug} spaceId={spaceId} />
        </div>
      </div>
    );
  }

  if (textBody) {
    return <Typography.BodyMd>{textBody}</Typography.BodyMd>;
  }

  if (trixBody) {
    return <DisplayTrixContent content={trixBody} disableFullScreenPreview />;
  }

  if (tiptapBody?.body?.content?.length) {
    return <DisplayTiptapContent tiptapBody={tiptapBody} />;
  }

  return (
    <Typography.LabelSm color="text-lightest">
      {t([i18nRoot, "empty"])}
    </Typography.LabelSm>
  );
};
